import React, { useState, useEffect } from 'react'
import './Header.scss'
import { ReactComponent as ArrowDown } from '../../assets/svg/ArrowDown.svg'
import { ReactComponent as User } from '../../assets/svg/Profile.svg'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as Logo } from '../../assets/svg/NewLogo.svg'
import { usePermissions } from '../../hooks/usePermissions'
import { shouldUseNewPermissions } from '../../utils/devMode'
import UserRoleIndicator from '../UserRoleIndicator/UserRoleIndicator'

import { ReactComponent as HeaderCart } from '../../assets/svg/Header/HeaderCart.svg'
import { ReactComponent as HeaderCatalog } from '../../assets/svg/Header/HeaderCatalog.svg'
import { ReactComponent as HeaderMessages } from '../../assets/svg/Header/HeaderMessages.svg'
import { ReactComponent as HeaderContacts } from '../../assets/svg/Header/HeaderPeople.svg'
import { ReactComponent as HeaderOperation } from '../../assets/svg/Header/HeaderOperation.svg'
import { ReactComponent as HeaderSuppliers } from '../../assets/svg/Header/HeaderSuppliers.svg'
import { ReactComponent as OperationFacturation } from '../../assets/svg/Header/OperationFacturation.svg'
import { ReactComponent as HeaderPeople } from '../../assets/svg/Header/HeaderPeople.svg'
import { ReactComponent as CristmasThree } from '../../assets/svg/Header/cristmasthree.svg'
import { ReactComponent as ResultIcon } from '../../assets/svg/Header/resultIcon.svg'

import { ReactComponent as HeaderIntegration } from '../../assets/svg/Header/HeaderIntegration.svg'
import { ReactComponent as HeaderDBarna } from '../../assets/svg/Header/HeaderDBarna.svg'
import { ReactComponent as LogoutIcon } from '../../assets/svg/Header/logoutBtn.svg'
import { Box, Button } from '@mui/material'
import { catalog } from '../../constants/Catalog'
import { contacts } from '../../constants/Contacts'
import { billings } from '../../constants/Billings'
import { operations } from '../../constants/Operations'
import { integrations } from '../../constants/Integrations'
import { suppliers } from '../../constants/Suppliers'
// import { SUPPLIERS__LIST } from '../../constants/SuppliersList'
import { useSuppliersList } from '../../constants/SuppliersList'
import { mainApi } from "../../store/services/mainApi";

import { overview } from '../../constants/Overview'
import {results} from "../../constants/Results";
import AddSupplierModal from "./AddSupplierModal";

export default function Header() {
  const [active, setActive] = useState('')
  const navigate = useNavigate()
  const { canView, userRole } = usePermissions()
  const useNewPermissions = shouldUseNewPermissions()

  const { SUPPLIERS_LIST, isLoading, refetch } = useSuppliersList()
  const [addSupplierLink, { isLoading: isCreating }] = mainApi.useAddSupplierLinkMutation()
  const [updateSupplierLink, { isLoading: isUpdating }] =
      mainApi.useUpdateSupplierLinkMutation()


  const [deleteSupplierLink, { isLoading: isDeleting }] = mainApi.useDeleteSupplierLinkMutation()

  const [openAddSupplier, setOpenAddSupplier] = useState(false)
  const [deletingTradeName, setDeletingTradeName] = useState(null)

  const handleCreateSupplier = async (payload) => {
    try {
      await addSupplierLink(payload).unwrap()
      setOpenAddSupplier(false)
      refetch?.()
    } catch (e) {
      alert(e?.data?.message || 'Create error')
    }
  }

  const handleUpdateSupplier = async (payload) => {
    try {
      await updateSupplierLink(payload).unwrap()
      setOpenAddSupplier(false)
      refetch?.()
    } catch (e) {
      alert(e?.data?.message || 'Update error')
    }
  }


  const handleDeleteSupplier = async (tradeName) => {
    if (!tradeName) return
    if (!window.confirm(`Delete supplier ${tradeName}?`)) return
    try {
      setDeletingTradeName(tradeName)
      await deleteSupplierLink(tradeName).unwrap()
      refetch?.()
    } catch (e) {
      alert(e?.data?.message || 'Delete error')
    } finally {
      setDeletingTradeName(null)
    }
  }

  const renderSupplierIcon = (el) => {
    if (el?.iconUrl) {
      return (
          <img
              src={el.iconUrl}
              alt={el.name || 'supplier'}
              width={30}
              height={30}
              style={{
                borderRadius: 6,
                objectFit: 'cover',
                display: 'block',
              }}
              onError={(e) => {
                // если ссылка битая — скрываем img, оставляя fallback
                e.currentTarget.style.display = 'none'
              }}
          />
      )
    }

    // fallback на локальную иконку, которую ты подмешиваешь в useSuppliersList
    return el.icon
  }


  const [logoutMenu, setLogoutMenu] = useState(false)

  const [burger, setBurger] = useState(false)

  const site = JSON.parse(localStorage.getItem('site'))
  const acc = JSON.parse(localStorage.getItem('acc'))

  useEffect(() => {
    setActive(window.location.pathname.split('/').pop())
  }, [])

  // To block scrolling
  function blockScroll() {
    document.body.style.overflow = 'hidden'
  }

  // To unblock scrolling
  function unblockScroll() {
    document.body.style.overflow = ''
  }

  useEffect(() => {
    if (burger) {
      blockScroll()
    } else {
      unblockScroll()
    }
  }, [burger])

  //open menu

  const [openContacts, setOpenContacts] = useState(false)
  const [openCatalog, setOpenCatalog] = useState(false)
  const [openBillings, setOpenBillings] = useState(false)
  const [openOperations, setOpenOperations] =
    useState(false)
  const [openIntegration, setOpenIntegration] =
    useState(false)
  const [openResults, setOpenResults] =
      useState(false)
  const [openSuppliers, setOpenSuppliers] = useState(false)
  const [openIntegrations, setOpenIntegrations] = useState(false)

  const handleLogout = () => {
    setLogoutMenu((prev) => !prev)
  }

  return (
    <header>
      <div className='header'>
        <div className='header__logo'>
          <img src={site?.logo || ''} height={30} />
          <h1>
            {site?.name || ''} <span>Admin</span>
          </h1>
        </div>
        <div className='header__menu'>
          <input type='checkbox' name='' id=''></input>
          <div
            className='header__menu__lines'
            onClick={() => setBurger(!burger)}
          >
            <span className='line line1'></span>
            <span className='line line2'></span>
            <span className='line line3'></span>
          </div>
          {burger && (
            <div
              className='header__menu__burger'
              onClick={() => setBurger(!burger)}
            >
              <div className='header__menu__burger__head'>
                <div className='header__menu__burger__head__logo'>
                  <Logo height={'28px'} width={'23px'} />
                  TPO Admin
                </div>
                <div
                  className='header__menu__lines'
                  onClick={() => setBurger(!burger)}
                >
                  <span className='line line1'></span>
                  <span className='line line2'></span>
                  <span className='line line3'></span>
                </div>
              </div>
              <div className='header__menu__burger__account'>
                {acc ? (
                  <div
                    className='header__menu__burger__account__image'
                    onClick={() =>
                      navigate('/admin/profile')
                    }
                  >
                    {acc?.name?.split(' ')[0]
                      ? acc?.name?.split(' ')[0][0]
                      : null}
                  </div>
                ) : (
                  <User
                    className='header__user__image'
                    onClick={() =>
                      navigate('/admin/profile')
                    }
                  />
                )}
                {acc && (
                  <div className='header__menu__burger__account__name'>
                    {acc?.name}
                  </div>
                )}
              </div>
              <div className='header__menu__burger__body'>
                <div className='header__menu__burger__body__item'>
                  <div className='header__menu__burger__body__item__title'>
                    Overview
                  </div>
                  <div className='header__menu__burger__body__item__lists'>
                    {overview.map((el) => {
                      // Проверяем права на основе модуля
                      const moduleName =
                        el.name.toLowerCase()
                      const hasAccess = useNewPermissions
                        ? canView(moduleName) ||
                          el.permission ||
                          true // Новая система прав
                        : el.permission // Старая система прав

                      return (
                        <div
                          key={el.name}
                          onClick={() => {
                            if (hasAccess) {
                              setActive(el.name)
                              if (
                                el.link.includes('https://')
                              ) {
                                window.open(el.link)
                              } else {
                                navigate(el.link)
                              }
                            } else {
                              navigate('/admin/noAccess')
                            }
                          }}
                          className='header__menu__burger__body__item__lists__item'
                          style={{
                            opacity: hasAccess
                              ? '1'
                              : '0.5',
                            cursor: hasAccess
                              ? 'pointer'
                              : 'not-allowed',
                            filter: hasAccess
                              ? 'none'
                              : 'brightness(0.5)',
                          }}
                        >
                          {el.icon({
                            stroke:
                              active === el.name
                                ? '#fff'
                                : 'none',
                          })}
                          {el.name}
                        </div>
                      )
                    })}
                    <div
                      onClick={() => {
                        // if (site.avalible.catalog) {
                        setActive('MBApp')
                        navigate('/admin/MBApp')
                        // } else {
                        //   navigate('/admin/noAccess')
                        // }
                      }}
                      className='header__menu__burger__body__item__lists__item'
                    >
                      <HeaderDBarna
                        height={30}
                        width={30}
                        stroke={
                          active === 'MBApp'
                            ? '#fff'
                            : 'none'
                        }
                      />
                      Mercabarna APP
                    </div>
                  </div>
                </div>
                <div className='header__menu__burger__body__item'>
                  <div className='header__menu__burger__body__item__title'>
                    Contacts
                  </div>
                  <div className='header__menu__burger__body__item__lists'>
                    {contacts.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'burgerCatalog' + index}
                            className='header__menu__burger__body__item__lists__item'
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                              cursor: el.disabled
                                ? 'not-allowed'
                                : 'pointer',
                              filter: el.disabled
                                ? 'brightness(0.5)'
                                : '',
                            }}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : ''
                            }
                            onClick={() => {
                              if (el.disabled) return
                              setOpenContacts(false)
                              if (el.permission) {
                                setActive('contacts')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                              setBurger(false)
                            }}
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </div>
                <div className='header__menu__burger__body__item'>
                  <div className='header__menu__burger__body__item__title'>
                    Catalog
                  </div>
                  <div className='header__menu__burger__body__item__lists'>
                    {catalog.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'burgerCatalog' + index}
                            className='header__menu__burger__body__item__lists__item'
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                              cursor: el.disabled
                                ? 'not-allowed'
                                : 'pointer',
                              filter: el.disabled
                                ? 'brightness(0.5)'
                                : '',
                            }}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : ''
                            }
                            onClick={() => {
                              if (el.disabled) return
                              setOpenCatalog(false)
                              if (el.permission) {
                                setActive('catalog')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                              setBurger(false)
                            }}
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </div>
                <div className='header__menu__burger__body__item'>
                  <div className='header__menu__burger__body__item__title'>
                    Billings
                  </div>
                  <div className='header__menu__burger__body__item__lists'>
                    {billings.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'burgerOperation' + index}
                            className='header__menu__burger__body__item__lists__item'
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                              cursor: el.disabled
                                ? 'not-allowed'
                                : 'pointer',
                              filter: el.disabled
                                ? 'brightness(0.5)'
                                : '',
                            }}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : ''
                            }
                            onClick={() => {
                              if (el.disabled) return
                              setOpenBillings(false)
                              if (el.permission) {
                                setActive('billings')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                              setBurger(false)
                            }}
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </div>
                <div className='header__menu__burger__body__item'>
                  <div className='header__menu__burger__body__item__title'>
                    Operations
                  </div>
                  <div className='header__menu__burger__body__item__lists'>
                    {operations.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'burgerOperation' + index}
                            className='header__menu__burger__body__item__lists__item'
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                              cursor: el.disabled
                                ? 'not-allowed'
                                : 'pointer',
                              filter: el.disabled
                                ? 'brightness(0.5)'
                                : '',
                            }}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : ''
                            }
                            onClick={() => {
                              if (el.disabled) return
                              setOpenOperations(false)
                              if (el.permission) {
                                setActive('operacion')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                              setBurger(false)
                            }}
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </div>
                <div className='header__menu__burger__body__item'>
                  <div className='header__menu__burger__body__item__title'>
                    Suppliers
                  </div>
                  <div className='header__menu__burger__body__item__lists'>
                    {suppliers.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'burgerSuppliers' + index}
                            className='header__menu__burger__body__item__lists__item'
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                              cursor: el.disabled
                                ? 'not-allowed'
                                : 'pointer',
                              filter: el.disabled
                                ? 'brightness(0.5)'
                                : '',
                            }}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : ''
                            }
                            onClick={() => {
                              if (el.disabled) return
                              setOpenSuppliers(false)
                              if (el.permission) {
                                setActive('suppliers')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                              setBurger(false)
                            }}
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                    {!isLoading &&
                        SUPPLIERS_LIST.map((el, index) =>
                            el.enabled ? (
                                <div
                                    key={'burgerSuppliersDB' + (el.tradeName ?? index)}
                                    className='header__menu__burger__body__item__lists__item'
                                    style={{
                                      opacity: el.disabled ? '0.5' : '1',
                                      cursor: el.disabled ? 'not-allowed' : 'pointer',
                                      filter: el.disabled ? 'brightness(0.5)' : '',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 10,
                                    }}
                                    onClick={() => {
                                      if (el.disabled) return

                                      // ✅ если это action-элемент — открываем модалку
                                      if (el.type === 'action' && el.action === 'openAddSupplierModal') {
                                        setOpenAddSupplier(true)
                                        return
                                      }

                                      // иначе обычный supplier
                                      setOpenSuppliers(false)
                                      if (el.permission) {
                                        setActive('suppliers')
                                        navigate('/admin/' + el.link)
                                      } else {
                                        navigate('/admin/noAccess')
                                      }
                                      setBurger(false)
                                    }}

                                >
                                  {renderSupplierIcon(el)}
                                  {el.name}
                                </div>
                            ) : null,
                        )
                    }



                  </div>
                </div>
                <div className='header__menu__burger__body__item'>
                  <div className='header__menu__burger__body__item__title'>
                    Integration
                  </div>
                  <div className='header__menu__burger__body__item__lists'>
                    {integrations.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'integration' + index}
                            onClick={() => {
                              if (el.disabled) return
                              setOpenIntegrations(false)
                              if (el.permission) {
                                setActive('integrations')
                                if (el.link.includes('https://')) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                              setBurger(false)
                            }}
                            className='header__menu__burger__body__item__lists__item'
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                              cursor: el.disabled
                                ? 'not-allowed'
                                : 'pointer',
                              filter: el.disabled
                                ? 'brightness(0.5)'
                                : '',
                            }}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : ''
                            }
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </div>
                <div className='header__menu__burger__body__item'>
                  <div className='header__menu__burger__body__item__title'>
                    Results
                  </div>
                  <div className='header__menu__burger__body__item__lists'>
                    {results.map(
                        (el, index) =>
                            el.enabled && (
                                <div
                                    key={'results' + index}
                                    onClick={() => {
                                      navigate('/admin/year?year='+el.link)
                                      if (el.disabled) return
                                      setOpenResults(false)
                                      if (el.permission) {
                                        setActive('results')
                                        if (el.link.includes('https://')) {
                                          window.open(el.link)
                                        } else {
                                          navigate(el.link)
                                        }
                                      } else {
                                        navigate('/admin/noAccess')
                                      }
                                      setBurger(false)
                                    }}
                                    className='header__menu__burger__body__item__lists__item'
                                    style={{
                                      opacity: el.disabled
                                          ? '0.5'
                                          : '1',
                                      cursor: el.disabled
                                          ? 'not-allowed'
                                          : 'pointer',
                                      filter: el.disabled
                                          ? 'brightness(0.5)'
                                          : '',
                                    }}
                                    title={
                                      el.disabled
                                          ? 'Coming soon'
                                          : ''
                                    }
                                >
                                  {el.icon}
                                  {el.name}
                                </div>
                            ),
                    )}
                  </div>
                </div>

              </div>
            </div>
          )}
          {overview.map((el) => {
            // Проверяем права на основе модуля
            const moduleName = el.name.toLowerCase()
            const hasAccess = useNewPermissions
              ? canView(moduleName) || el.permission || true // Новая система прав
              : el.permission // Старая система прав

            return (
              <div
                key={el.name}
                className={
                  active === el.name
                    ? 'header__menu__item active'
                    : 'header__menu__item'
                }
                onClick={() => {
                  if (hasAccess) {
                    setActive(el.name)
                    if (el.link.includes('https://')) {
                      window.open(el.link)
                    } else {
                      navigate(el.link)
                    }
                  } else {
                    navigate('/admin/noAccess')
                  }
                }}
                style={{
                  opacity: hasAccess ? '1' : '0.5',
                  cursor: hasAccess
                    ? 'pointer'
                    : 'not-allowed',
                  filter: hasAccess
                    ? 'none'
                    : 'brightness(0.5)',
                }}
              >
                {el.icon()}
                {el.name}
              </div>
            )
          })}
          <div
            style={{ position: 'relative' }}
            className={
              active === 'contacts'
                ? 'header__menu__item active'
                : 'header__menu__item'
            }
            onMouseEnter={() => setOpenContacts(true)}
            onMouseLeave={() => setOpenContacts(false)}
          >
            <HeaderContacts height={30} width={30} onClick={() => {navigate('/admin/contacts')}} />
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Contacts{' '}
              <ArrowDown
                className='header__menu__item__icon'
                stroke='#06C0B0'
                fill='#06C0B0'
              />
            </span>
            {openContacts && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%',
                  // transform: 'translateX(-50%)',
                  width: '500px',
                  zIndex: '2',
                }}
              >
                <Box
                  sx={{
                    marginTop: '10px',
                    left: '0',
                    boxShadow:
                      '0 1px 10px 0 rgba(0, 0, 0, 0.25)',
                    backgroundColor: 'white',
                    display: 'flex',

                    flexWrap: 'wrap',
                    padding: '20px',
                    borderRadius: '10px',
                    animation: 'slideDown 0.5s ease-in-out',
                  }}
                >
                  <div className='header__menu__item__open__title'>
                    Contacts
                  </div>
                  <div className='header__menu__item__open__operations'>
                    {contacts.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'contacts ' + index}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : el.name
                            }
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                            }}
                            onClick={() => {
                              if (el.disabled) return
                              if (el.permission) {
                                setActive('contacts')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                            }}
                            className='header__menu__item__open'
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </Box>
              </Box>
            )}
          </div>
          <div
            style={{ position: 'relative' }}
            className={
              active === 'catalog'
                ? 'header__menu__item active'
                : 'header__menu__item'
            }
            onMouseEnter={() => setOpenCatalog(true)}
            onMouseLeave={() => setOpenCatalog(false)}
          >
            <HeaderCatalog height={30} width={30} />
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Catalog{' '}
              <ArrowDown
                className='header__menu__item__icon'
                stroke='#06C0B0'
                fill='#06C0B0'
              />
            </span>
            {openCatalog && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%',
                  // transform: 'translateX(-50%)',
                  width: '500px',
                  zIndex: '2',
                }}
              >
                <Box
                  sx={{
                    marginTop: '10px',
                    left: '0',
                    boxShadow:
                      '0 1px 10px 0 rgba(0, 0, 0, 0.25)',
                    backgroundColor: 'white',
                    display: 'flex',

                    flexWrap: 'wrap',
                    padding: '20px',
                    borderRadius: '10px',
                    animation: 'slideDown 0.5s ease-in-out',
                  }}
                >
                  <div className='header__menu__item__open__title'>
                    Catalog
                  </div>
                  {/* <div
                    onClick={() => {
                      setActive('operacion')
                      navigate('/admin/orders')
                    }}
                    className='header__menu__item__open'
                  >
                    Billing
                  </div> */}
                  <div className='header__menu__item__open__operations'>
                    {catalog.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'catalog ' + index}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : el.name
                            }
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                            }}
                            onClick={() => {
                              if (el.disabled) return
                              if (el.permission) {
                                setActive('catalog')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                            }}
                            className='header__menu__item__open'
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </Box>
              </Box>
            )}
          </div>
          <div
            style={{ position: 'relative' }}
            className={
              active === 'billings'
                ? 'header__menu__item active'
                : 'header__menu__item'
            }
            onMouseEnter={() => setOpenBillings(true)}
            onMouseLeave={() => setOpenBillings(false)}
          >
            <OperationFacturation height={35} width={35} />
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Billings{' '}
              <ArrowDown
                className='header__menu__item__icon'
                stroke='#06C0B0'
                fill='#06C0B0'
              />
            </span>
            {openBillings && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%',
                  // transform: 'translateX(-50%)',
                  width: '500px',
                  zIndex: '2',
                }}
              >
                <Box
                  sx={{
                    marginTop: '10px',
                    left: '0',
                    boxShadow:
                      '0 1px 10px 0 rgba(0, 0, 0, 0.25)',
                    backgroundColor: 'white',
                    display: 'flex',

                    flexWrap: 'wrap',
                    padding: '20px',
                    borderRadius: '10px',
                    animation: 'slideDown 0.5s ease-in-out',
                  }}
                >
                  <div className='header__menu__item__open__title'>
                    Billings
                  </div>
                  {/* <div
                    onClick={() => {
                      setActive('operacion')
                      navigate('/admin/orders')
                    }}
                    className='header__menu__item__open'
                  >
                    Billing
                  </div> */}
                  <div className='header__menu__item__open__operations'>
                    {billings.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'billings ' + index}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : el.name
                            }
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                            }}
                            onClick={() => {
                              if (el.disabled) return
                              if (el.permission) {
                                setActive('billings')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                            }}
                            className='header__menu__item__open'
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </Box>
              </Box>
            )}
          </div>
          <div
            style={{ position: 'relative' }}
            className={
              active === 'operacion'
                ? 'header__menu__item active'
                : 'header__menu__item'
            }
            onMouseEnter={() => setOpenOperations(true)}
            onMouseLeave={() => setOpenOperations(false)}
          >
            <HeaderOperation height={30} width={30} />
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Operations{' '}
              <ArrowDown
                className='header__menu__item__icon'
                stroke='#06C0B0'
                fill='#06C0B0'
              />
            </span>
            {openOperations && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%',
                  // transform: 'translateX(-50%)',
                  width: '500px',
                  zIndex: '2',
                }}
              >
                <Box
                  sx={{
                    marginTop: '10px',
                    left: '0',
                    boxShadow:
                      '0 1px 10px 0 rgba(0, 0, 0, 0.25)',
                    backgroundColor: 'white',
                    display: 'flex',

                    flexWrap: 'wrap',
                    padding: '20px',
                    borderRadius: '10px',
                    animation: 'slideDown 0.5s ease-in-out',
                  }}
                >
                  <div className='header__menu__item__open__title'>
                    Operations
                  </div>
                  {/* <div
                    onClick={() => {
                      setActive('operacion')
                      navigate('/admin/orders')
                    }}
                    className='header__menu__item__open'
                  >
                    Billing
                  </div> */}
                  <div className='header__menu__item__open__operations'>
                    {operations.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'operation ' + index}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : el.name
                            }
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                            }}
                            onClick={() => {
                              if (el.disabled) return
                              if (el.permission) {
                                setActive('operacion')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                            }}
                            className='header__menu__item__open'
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </Box>
              </Box>
            )}
          </div>
          <div
            style={{ position: 'relative' }}
            className={
              active === 'suppliers'
                ? 'header__menu__item active'
                : 'header__menu__item'
            }
            onMouseEnter={() => setOpenSuppliers(true)}
            onMouseLeave={() => setOpenSuppliers(false)}
          >
            <HeaderSuppliers height={30} width={30} />
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Suppliers{' '}
              <ArrowDown
                className='header__menu__item__icon'
                stroke='#06C0B0'
                fill='#06C0B0'
              />
            </span>
            {openSuppliers && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%',
                  // transform: 'translateX(-50%)',
                  width: '500px',
                  zIndex: '2',
                }}
              >
                <Box
                  sx={{
                    marginTop: '10px',
                    left: '0',
                    boxShadow:
                      '0 1px 10px 0 rgba(0, 0, 0, 0.25)',
                    backgroundColor: 'white',
                    display: 'flex',

                    flexWrap: 'wrap',
                    padding: '20px',
                    borderRadius: '10px',
                    animation: 'slideDown 0.5s ease-in-out',
                  }}
                >
                  <div className='header__menu__item__open__title'>
                    Suppliers
                  </div>
                  {/* <div
                    onClick={() => {
                      setActive('operacion')
                      navigate('/admin/orders')
                    }}
                    className='header__menu__item__open'
                  >
                    Billing
                  </div> */}
                  <div className='header__menu__item__open__operations'>
                    {suppliers.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'suppliers ' + index}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : el.name
                            }
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                            }}
                            onClick={() => {
                              if (el.disabled) return
                              if (el.permission) {
                                setActive('suppliers')
                                if (
                                  el.link.includes(
                                    'https://',
                                  )
                                ) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                            }}
                            className='header__menu__item__open'
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                    {!isLoading &&
                        SUPPLIERS_LIST.map((el, index) =>
                            el.enabled ? (
                                <div
                                    key={'suppliersDB ' + (el.tradeName ?? index)}
                                    title={el.disabled ? 'Coming soon' : el.name}
                                    style={{
                                      opacity: el.disabled ? '0.5' : '1',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 10,
                                    }}
                                    onClick={() => {
                                      if (el.disabled) return

                                      // ✅ если это action-элемент — открываем модалку
                                      if (el.type === 'action' && el.action === 'openAddSupplierModal') {
                                        setOpenAddSupplier(true)
                                        return
                                      }

                                      // иначе обычный supplier
                                      setOpenSuppliers(false)
                                      if (el.permission) {
                                        setActive('suppliers')
                                        navigate('/admin/' + el.link)
                                      } else {
                                        navigate('/admin/noAccess')
                                      }
                                      setBurger(false)
                                    }}

                                    className='header__menu__item__open'
                                >
                                  {renderSupplierIcon(el)}
                                  {el.name}
                                </div>
                            ) : null,
                        )
                    }



                  </div>
                </Box>
              </Box>
            )}
          </div>
          <div
            style={{ position: 'relative' }}
            className={
              active === 'projects'
                ? 'header__menu__item active'
                : 'header__menu__item'
            }
            onMouseEnter={() => setOpenIntegration(true)}
            onMouseLeave={() => setOpenIntegration(false)}
          >
            <HeaderIntegration width={30} height={30} />
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Integration{' '}
              <ArrowDown
                className='header__menu__item__icon'
                stroke='#06C0B0'
                fill='#06C0B0'
              />
            </span>
            {openIntegration && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%',
                  // transform: 'translateX(-50%)',
                  width: '500px',
                  zIndex: '2',
                }}
              >
                <Box
                  sx={{
                    marginTop: '10px',
                    left: '0',
                    boxShadow:
                      '0 1px 10px 0 rgba(0, 0, 0, 0.25)',
                    backgroundColor: 'white',
                    display: 'flex',

                    flexWrap: 'wrap',
                    padding: '20px',
                    borderRadius: '10px',
                    animation: 'slideDown 0.5s ease-in-out',
                  }}
                >
                  <div className='header__menu__item__open__title'>
                    Integration
                  </div>
                  {/* <div
                    onClick={() => {
                      setActive('operacion')
                      navigate('/admin/orders')
                    }}
                    className='header__menu__item__open'
                  >
                    Billing
                  </div> */}
                  <div className='header__menu__item__open__operations'>
                    {integrations.map(
                      (el, index) =>
                        el.enabled && (
                          <div
                            key={'operation ' + index}
                            title={
                              el.disabled
                                ? 'Coming soon'
                                : el.name
                            }
                            style={{
                              opacity: el.disabled
                                ? '0.5'
                                : '1',
                            }}
                            onClick={() => {
                              if (el.disabled) return

                              if (
                                el.link.includes('https://')
                              ) {
                                window.open(
                                  el.link,
                                  '_blank',
                                )
                                return
                              }

                              if (el.permission) {
                                setActive('integrations')
                                if (el.link.includes('https://')) {
                                  window.open(el.link)
                                } else {
                                  navigate(el.link)
                                }
                              } else {
                                navigate('/admin/noAccess')
                              }
                            }}
                            className='header__menu__item__open'
                          >
                            {el.icon}
                            {el.name}
                          </div>
                        ),
                    )}
                  </div>
                </Box>
              </Box>
            )}
          </div>
          <div
              style={{ position: 'relative' }}
              className={
                active === 'projects'
                    ? 'header__menu__item active'
                    : 'header__menu__item'
              }
              onMouseEnter={() => setOpenResults(true)}
              onMouseLeave={() => setOpenResults(false)}
          >
            <ResultIcon width={30} height={30} />
            <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
            >
              Results{' '}
              <ArrowDown
                  className='header__menu__item__icon'
                  stroke='#06C0B0'
                  fill='#06C0B0'
              />
            </span>
            {openResults && (
                <Box
                    sx={{
                      position: 'absolute',
                      top: '100%',
                      // transform: 'translateX(-50%)',
                      width: '500px',
                      zIndex: '2',
                    }}
                >
                  <Box
                      sx={{
                        marginTop: '10px',
                        left: '0',
                        boxShadow:
                            '0 1px 10px 0 rgba(0, 0, 0, 0.25)',
                        backgroundColor: 'white',
                        display: 'flex',

                        flexWrap: 'wrap',
                        padding: '20px',
                        borderRadius: '10px',
                        animation: 'slideDown 0.5s ease-in-out',
                      }}
                  >
                    <div className='header__menu__item__open__title'>
                      Results
                    </div>
                    {/* <div
                    onClick={() => {
                      setActive('operacion')
                      navigate('/admin/orders')
                    }}
                    className='header__menu__item__open'
                  >
                    Billing
                  </div> */}
                    <div className='header__menu__item__open__operations'>
                      {results.map(
                          (el, index) =>
                              el.enabled && (
                                  <div
                                      key={'operation ' + index}
                                      title={
                                        el.disabled
                                            ? 'Coming soon'
                                            : el.name
                                      }
                                      style={{
                                        opacity: el.disabled
                                            ? '1'
                                            : '1',
                                      }}
                                      onClick={() => {
                                        navigate('/admin/year?year='+el.link)
                                        if (el.disabled) return

                                        if (
                                            el.link.includes('https://')
                                        ) {
                                          window.open(
                                              el.link,
                                              '_blank',
                                          )
                                          return
                                        }

                                        if (el.permission) {
                                          setActive('integrations')
                                          if (el.link.includes('https://')) {
                                            window.open(el.link)
                                          } else {
                                            navigate(el.link)
                                          }
                                        } else {
                                          navigate('/admin/noAccess')
                                        }
                                      }}
                                      className='header__menu__item__open'
                                  >
                                    {el.icon}
                                    {el.name}
                                  </div>
                              ),
                      )}
                    </div>
                  </Box>
                </Box>
            )}
          </div>
          <div
            onClick={() => {
              // if (site.avalible.catalog) {
              setActive('MBApp')
              navigate('/admin/MBApp')
              // } else {
              //   navigate('/admin/noAccess')
              // }
            }}
            className={
              active === 'MBApp'
                ? 'header__menu__item active'
                : 'header__menu__item'
            }
          >
            <HeaderDBarna
              height={30}
              width={30}
              stroke={active === 'MBApp' ? '#fff' : 'none'}
            />
            Mercabarna App
          </div>
        </div>
        <div className='header__user'>
          {/* <div className='header__user__lang'>
            <p style={{ color: '#176318' }}>CAT</p>
            <ArrowDown className='header__user__lang__icon' stroke='#176318' fill='#176318' />
          </div> */}
          <UserRoleIndicator />
          {acc ? (
            <div
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: '#176318',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                color: '#f0f0f0',
                fontFamily: 'Inter',
                fontSize: '18px',
                fontWeight: '400',
                lineHeight: 'normal',
              }}
              onClick={() => navigate('/admin/profile')}
            >
              {acc?.name?.split(' ')[0]
                ? acc?.name?.split(' ')[0][0]
                : null}
            </div>
          ) : (
            <User
              className='header__user__image'
              onClick={() => navigate('/admin/profile')}
            />
          )}
          <Button
            onClick={() => {
              localStorage.removeItem('password')
              localStorage.removeItem('acc')
              localStorage.removeItem('profileID')
              navigate('/admin/auth')
            }}
            color='error'
            className='header__user__logoutButton'
            sx={{ width: 'fit-content' }}
          >
            <LogoutIcon />
          </Button>
        </div>
      </div>
      <AddSupplierModal
          open={openAddSupplier}
          onClose={() => setOpenAddSupplier(false)}
          onSubmit={handleCreateSupplier}
          onUpdate={handleUpdateSupplier}
          loading={isLoading || isUpdating}
          suppliers={SUPPLIERS_LIST}
          onDelete={handleDeleteSupplier}
          deletingTradeName={deletingTradeName}
      />

    </header>
  )
}

//setActive('operacion')
//              navigate('/admin/history')
